import styles from './HomePage.module.css'
import { useCity } from '../contexts/CityContext';
import { useAuth } from '../contexts/AuthContext';
import AdBanner from '../components/ads/AdBanner';

function HomePage() {
  const { currentCity } = useCity();
  const { isPremium } = useAuth();
  // Horizontal kaydırma artık sadece doğal touch/trackpad ile yapılacak.

  return (
    <div className={styles.homePage}>
      {!isPremium && (
        <AdBanner className={styles.mainAdBanner} />
      )}

      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>vagonla ile Toplu Taşıma</h1>
            <p className={styles.heroSubtitle}>
              {currentCity ? (
                <><strong>{currentCity.cityName}</strong> için tüm ulaşım bilgileri tek bir uygulamada!</>
              ) : (
                <>Şehrini seç, tüm toplu taşıma araçları tek yerde birleşsin.</>
              )}
            </p>
        </div>
      </section>

    </div>
  )
}

export default HomePage
